import { useLDClientError } from 'launchdarkly-react-client-sdk';
import { useEffect } from 'react';
import { BooleanFeatureFlag } from './booleanFlags';
import { useFeatureFlagEnabledBoolean } from './use-boolean-flag';
import { captureErrorInSentryWithCustomMessage } from '../utils/capture-error-in-sentry-with-custom-message';

export const useAreFeatureFlagsLoading = () => {
  const flagsLoading = useFeatureFlagEnabledBoolean(
    BooleanFeatureFlag.LAUNCHDARKLY_FLAGS_LOADING,
  );

  const launchdarklyClientError = useLDClientError();

  useEffect(() => {
    if (launchdarklyClientError) {
      captureErrorInSentryWithCustomMessage(
        launchdarklyClientError,
        'LaunchDarkly client error occurred. Flags will have their default values.',
      );
    }
  }, [launchdarklyClientError]);

  return flagsLoading && !launchdarklyClientError;
};
